var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrawlspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 9.16699V4.16699H18.3327V9.16699H13.3327ZM13.3327 15.8337H18.3327V10.8337H13.3327V15.8337ZM11.666 4.16699V15.8337H1.66602V4.16699H11.666ZM7.91602 10.0003C7.91602 9.30866 7.35768 8.75033 6.66602 8.75033C5.97435 8.75033 5.41602 9.30866 5.41602 10.0003C5.41602 10.692 5.97435 11.2503 6.66602 11.2503C7.35768 11.2503 7.91602 10.692 7.91602 10.0003Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrawlspace);
export default __webpack_public_path__ + "static/media/crawlspace.481919f78746b2b9ac77984e28c8c0f4.svg";
export { ForwardRef as ReactComponent };